export default __webpack_public_path__ + "static/media/Icon_stc.132d67c0.png";